import { useModalContext } from '../modal'
import * as React from 'react'
import cls from 'classnames'
import styles from './modal-header.module.css'
import type * as Polymorphic from '../../../../react-utils/polymorphic'

export interface ModalHeaderProps extends React.HTMLAttributes<HTMLElement> {}

/**
 * ModalHeader
 *
 * React component that houses the title of the modal.
 *
 */
export const ModalHeader = React.forwardRef((props, ref) => {
  const { className, ...rest } = props

  const { headerId, setHeaderMounted } = useModalContext()

  /**
   * Notify us if this component was rendered or used
   * so we can append `aria-labelledby` automatically
   */
  React.useEffect(() => {
    setHeaderMounted(true)
    return () => setHeaderMounted(false)
  }, [setHeaderMounted])

  const _className = cls(styles.paypal_modal__header, className)

  const headerStyles: React.CSSProperties = {
    flex: 0,
    margin: '1rem 1.5rem 0',
  }

  return (
    <header
      ref={ref as any}
      className={_className}
      id={headerId}
      {...rest}
      style={{ ...headerStyles }}
    />
  )
}) as Polymorphic.ForwardRefComponent<'header', ModalHeaderProps>

ModalHeader.displayName = 'ModalHeader'
